module.exports = __webpack_public_path__ + "d6f15f6a24a7149aed466b607bebc823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/desktop.jpg
// module id = 641
// module chunks = 47